/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1ProgrammeLesson
 */
export interface V1ProgrammeLesson {
    /**
     *
     */
    id?: string
    /**
     *
     */
    name?: string
    /**
     *
     */
    items?: Array<object>
}

/**
 * Check if a given object implements the V1ProgrammeLesson interface.
 */
export function instanceOfV1ProgrammeLesson(
    value: object
): value is V1ProgrammeLesson {
    return true
}

export function V1ProgrammeLessonFromJSON(json: any): V1ProgrammeLesson {
    return V1ProgrammeLessonFromJSONTyped(json, false)
}

export function V1ProgrammeLessonFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ProgrammeLesson {
    if (json == null) {
        return json
    }
    return {
        id: json['id'] == null ? undefined : json['id'],
        name: json['name'] == null ? undefined : json['name'],
        items: json['items'] == null ? undefined : json['items']
    }
}

export function V1ProgrammeLessonToJSON(json: any): V1ProgrammeLesson {
    return V1ProgrammeLessonToJSONTyped(json, false)
}

export function V1ProgrammeLessonToJSONTyped(
    value?: V1ProgrammeLesson | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        name: value['name'],
        items: value['items']
    }
}
